import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../Config';

const GenericGuideRemark = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-remark'>
            <div className='remark-wrapper'>
                { 
                    props.iContent.icon?.expandedValue?.url &&
                    <div className='icon-wrapper'> <Image src={Config.epiBaseUrl + props.iContent.icon?.expandedValue?.url} /> </div>
                }                
                <div className='text-wrapper' dangerouslySetInnerHTML={{ __html: updateRelativeLinks(props.iContent.remark?.value) }}></div>
            </div>
        </div>
    );


    function updateRelativeLinks(htmlString) {
        const baseUrl = Config.staticWebSiteUrl;
        // Parse the HTML string into a DOM
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Select all anchor tags
        const anchors = doc.querySelectorAll('a');

        anchors.forEach(anchor => {
            const href = anchor.getAttribute('href');

            // Check if href is a relative path
            if (href && !href.startsWith('http') && !href.startsWith('//') && !href.startsWith('#') && !href.includes('globalassets')) {
                const target = anchor.getAttribute('target');
                if(target === '_blank') {
                    anchor.setAttribute('href', '#');
                    anchor.setAttribute('rel', 'noopener noreferrer');
                    anchor.setAttribute('onclick', `window.open('${new URL(href, baseUrl).href}', '_blank', 'noopener,noreferrer'); return false;`);
                }
                else {
                    anchor.setAttribute('href', new URL(href, baseUrl).href);
                }
            }
        });

        // Return the updated HTML string
        return doc.documentElement.outerHTML;
    }  

};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideRemark);